import yup from 'yup'

const schema = yup
  .object()
  .shape({
    name: yup.string().min(3, 'Minimum 3 characters')
                      .max(64, 'Too long (max 64 characters)')
                      .required('Leave type is required'),
  })

export default schema



// WEBPACK FOOTER //
// ./src/forms/Leave/schema.js